import { Form as RSForm, FormGroup as RSFormGroup, Input as RSInput, Label as RSLabel } from 'reactstrap'
import styled from 'styled-components'

export const Form = styled(RSForm)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
  margin: auto;
  margin-top: 250px;
`;

export const FormGroup = styled(RSFormGroup)`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

export const Input = styled.input`
  padding: 10px;
  color: black;
  width: ${({ type }) => (type === 'radio' ? 'auto' : '400px')};
  margin-right: auto;
  font-size: 40px;
  width: 530px;
  background-color: #F0D8C0;

  /* Estilo específico para rádio */
  ${({ type }) =>
    type === 'radio' &&
    `
    appearance: none;
    width: 30px; /* Tamanho da bolinha */
    height: 30px;
    border: 2px solid black; /* Cor da borda */
    border-radius: 50%; /* Formato circular */
    background-color: #F0D8C0;
    cursor: pointer;

    &:checked {
      background-color: F0D8C0; /* Cor quando selecionado */
    }
  `}
`;

export const Label = styled(RSLabel)`
  color: #F0D8C0;
  margin-bottom: 5px;
  width: 330px;
  margin-right: auto;
  font-size: 30px;
  font-weight: bold;
  margin-top: 50px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  height: 100vh;
  width: 100%;
  background-color: black;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 1; /* Garante visibilidade sobre outros elementos */
`;

export const Logo = styled.img`
  width: 700px;
  height: auto;
  margin-bottom: 20px;
  margin-top: 250px;

  &:first-child {
    margin-right: 50px;
  }
`;

export const Rodape = styled.img`
  position: fixed;
  width: 400px;
  height: auto;
  bottom: 80px;
  margin-left: auto;
  margin-right: auto;

  &:first-child {
    margin-right: 50px;
  }
`;

export const ErrorLabel = styled.label`
  color: red;
  margin-top: 10px;
  font-size: 24px;
`;

export const Button = styled.button`
  background-color: #F0D8C0;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 330px;
  height: 120px;
  margin: auto;
  margin-top: 200px;
  font-size: 40px;
  font-weight: bold;
  border-radius: 60px;
`;

export const ButtonLogoff = styled.button`
  background-color: white;
  color: black;
  padding: 0px 20px;
  border: none;
  cursor: pointer;
  width: 80px;
  height: 20px;
  margin: auto;
  margin-bottom: 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const TitleDiv = styled.div`
  width: 80%;
  margin: auto;
  font-size: 1.9em;
  color: black;
  text-align: justify;
  word-spacing: -2px;
  margin-top: -5px;
  line-height: 40px;
`;

export const StyledRadio = styled(Input)`
  appearance: none; /* Remove o estilo padrão */
  width: 30px; /* Tamanho da bolinha */
  height: 30px;
  border: 2px solid #000; /* Borda visível */
  border-radius: 50%; /* Formato circular */
  background-color: #f0d8c0; /* Cor de fundo */
  cursor: pointer;
  position: relative;

  &:checked {
    background-color: #000; /* Preenchimento quando selecionado */
  }

  &:checked::before {
    content: '';
    position: absolute;
    top: 7px; /* Centraliza o círculo interno */
    left: 7px;
    width: 14px; /* Tamanho do preenchimento interno */
    height: 14px;
    background-color: white; /* Cor do círculo interno */
    border-radius: 50%;
  }
`;

